import React from 'react';
import "./HomeCard.css";

const HomeCard = ({ title, text }) => {
  return (
    <div className="home-card p-4" >
  {/* <div className="icon-circle mb-3">📍</div> */}
  <h3>{title}</h3>
  <p className="text">{text}</p>
</div>


  );
};

export default HomeCard;
